/**
 * Tooltip de pines de lugares. No reusa `terrio-parcel-tooltip`: ese tiene
 * alto fijo y ellipsis (paridad con la publicación). Acá el nombre va completo.
 */
import { referencePlaceKindLabel } from '../data/referencePlaceKinds';

const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const toText = (value) => {
  if (value == null) return null;
  const text = String(value).trim();
  return text.length > 0 ? text : null;
};

const looksLikeKindSlug = (value, kind) => {
  const text = toText(value);
  const slug = String(kind || '').trim();
  if (!text || !slug) return false;
  return text.toLowerCase() === slug.toLowerCase();
};

/**
 * Título = tipo en español. Cuerpo = nombre de la institución, sin recortar.
 * Si el tile mandó el slug como `name` (`park`), no se muestra.
 *
 * @param {object} [properties]
 * @returns {string|null}
 */
export function buildReferencePlaceTooltipHtml(properties = {}) {
  const kind = properties.kind;
  const catalogLabel = toText(properties.kindLabel);
  const title = (
    (catalogLabel && !looksLikeKindSlug(catalogLabel, kind) ? catalogLabel : null)
    || toText(referencePlaceKindLabel(kind))
    || catalogLabel
    || toText(kind)
  );
  const name = looksLikeKindSlug(properties.name, kind) ? null : toText(properties.name);
  if (!title && !name) return null;

  const html = [];
  if (title && name && title !== name) {
    html.push(`<div class="terrio-place-tooltip__title">${escapeHtml(title)}</div>`);
    html.push(`<div class="terrio-place-tooltip__name">${escapeHtml(name)}</div>`);
    return html.join('');
  }

  const only = name || title;
  html.push(`<div class="terrio-place-tooltip__name">${escapeHtml(only)}</div>`);
  return html.join('');
}
